import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';

const DebouncedSearch: React.FC<{
  delay: number;
  placeholder: string;
  label: string;
  onDebounce: (value: string) => void;
  size: 'small' | 'medium';
}> = (props) => {
  const { delay, size, label, onDebounce, placeholder } = props;
  const [inputValue, setInputValue] = useState('');

  // Debounce logic
  useEffect(() => {
    const handler = setTimeout(() => {
      onDebounce(inputValue);
    }, delay); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue, delay]);

  return (
    <TextField
      size={size}
      fullWidth
      label={label}
      placeholder={placeholder}
      variant="outlined"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
    />
  );
};

export default DebouncedSearch;
